const AIS_DIFFERENCE_LEVELS = ['GREEN', 'AMBER', 'RED'] as const
export type AisDifferenceLevel = (typeof AIS_DIFFERENCE_LEVELS)[number]

export type AisDifferenceIntervals = readonly { level: Exclude<AisDifferenceLevel, 'RED'>; upToS: number }[]

export const AIS_DIFFERENCE_INTERVALS: AisDifferenceIntervals = [
  { level: 'GREEN', upToS: 15 * 60 },
  { level: 'AMBER', upToS: 60 * 60 },
]

export const AIS_DIFFERENCE_COLORS: Record<AisDifferenceLevel, string> = {
  GREEN: '#1F9D6B',
  AMBER: '#D97706',
  RED: '#DC2626',
}

export const aisDifferenceLevel = (differenceS: number, intervals: AisDifferenceIntervals = AIS_DIFFERENCE_INTERVALS): AisDifferenceLevel =>
  intervals.find(({ upToS }) => Math.abs(differenceS) <= upToS)?.level ?? 'RED'

export interface SignedDuration {
  sign: '+' | '−'
  hours: number
  minutes: number
}

export const signedDuration = (differenceS: number): SignedDuration => {
  const minutes = Math.round(Math.abs(differenceS) / 60)
  return { sign: differenceS < 0 ? '−' : '+', hours: Math.floor(minutes / 60), minutes: minutes % 60 }
}
